import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { useMutation } from "react-query";

export type DeleteRoleActionRequest = {
  id: number | string;
};

export type DeleteRoleActionResponse = BaseResponse<any>;

async function deleteRoleAction(data: DeleteRoleActionRequest): Promise<any> {
  try {
    const id1 = data.id;
    return (await axiosInstance.delete(`/RoleAction/Delete?id=${id1}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useDeleteRoleAction() {
  return useMutation<any, Error, DeleteRoleActionRequest>((variables) =>
    deleteRoleAction(variables)
  );
}
